export type CityFaq = { q: string; a: string };

export const CITY_FAQS: Record<string, CityFaq[]> = {
  krakow: [
    {
      q: "Ile kosztuje przegląd instalacji elektrycznej w Krakowie?",
      a: "Ceny przeglądów elektrycznych w Krakowie wynoszą zazwyczaj 250–500 zł netto za lokal. Starsze kamienice Kazimierza, Podgórza czy Starego Miasta bywają droższe ze względu na bardziej rozbudowane instalacje i konieczność wystawienia szczegółowego protokołu. Dokładna wycena zależy od metrażu i liczby obwodów.",
    },
    {
      q: "Jak często trzeba robić przegląd gazowy w Krakowie?",
      a: "Przegląd instalacji gazowej w Krakowie musi odbywać się co najmniej raz w roku, niezależnie od dzielnicy i rodzaju budynku. Wynika to z art. 62 Prawa budowlanego i dotyczy zarówno historycznych kamienic Starego Miasta, jak i bloków na Nowej Hucie czy Mistrzejowicach.",
    },
    {
      q: "Czy instalacje aluminiowe w krakowskich kamienicach są niebezpieczne?",
      a: "Wiele kamienic w Krakowie, szczególnie sprzed 1970 roku, posiada instalacje aluminiowe lub z izolacją papierową. Instalacja aluminiowa nie jest automatycznie nielegalna, jednak stanowi podwyższone ryzyko pożarowe — uprawniony elektryk po przeglądzie wskaże zakres ewentualnych prac modernizacyjnych.",
    },
    {
      q: "Jak szybko można umówić przegląd instalacji w Krakowie?",
      a: "Przez platformę inspektomat.pl jedno zapytanie trafia jednocześnie do certyfikowanych firm działających w Krakowie. Wizyta jest realizowana zazwyczaj w ciągu 7 dni od zgłoszenia — bez konieczności dzwonienia do każdego wykonawcy osobno.",
    },
  ],

  warszawa: [
    {
      q: "Ile kosztuje przegląd instalacji gazowej w Warszawie?",
      a: "Ceny przeglądów gazowych w Warszawie wynoszą zazwyczaj 150–350 zł netto za mieszkanie. Lokalizacja ma wpływ na stawkę — w Śródmieściu i na Mokotowie ceny bywają wyższe niż na obrzeżach. Platforma umożliwia porównanie ofert firm z różnych dzielnic bez zobowiązań.",
    },
    {
      q: "Czy zarządca wspólnoty w Warszawie musi organizować przeglądy instalacji?",
      a: "Tak. Zarządca nieruchomości w Warszawie ma ustawowy obowiązek zapewnienia corocznych przeglądów instalacji gazowych i pięcioletnich przeglądów elektrycznych we wszystkich budynkach objętych zarządem. Brak aktualnej dokumentacji przeglądowej może skutkować odpowiedzialnością prawną i problemami ubezpieczeniowymi.",
    },
    {
      q: "Jakie usterki są najczęstsze w warszawskich blokach z lat 70.?",
      a: "W blokach z okresu PRL na Ursynowie, Targówku czy w Białołęce najczęściej stwierdza się aluminiowe przewody elektryczne, zużyte tablice bezpiecznikowe oraz przestarzałe rury gazowe. Przegląd pozwala ocenić aktualny stan i zaplanować modernizację z wyprzedzeniem.",
    },
    {
      q: "Jak znaleźć certyfikowanego wykonawcę przeglądów w Warszawie?",
      a: "Wypełnij formularz na inspektomat.pl, a zgłoszenie trafi jednocześnie do kilku certyfikowanych firm działających w Warszawie. Możesz porównać oferty, sprawdzić opinie poprzednich klientów i wybrać specjalistę bez zbędnego szukania.",
    },
  ],

  wroclaw: [
    {
      q: "Ile kosztuje przegląd instalacji we Wrocławiu?",
      a: "We Wrocławiu ceny przeglądów elektrycznych wynoszą zazwyczaj 230–480 zł netto, a gazowych 140–320 zł netto za lokal. Budynki przedwojenne ze Starego Miasta czy Śródmieścia wymagają często bardziej szczegółowej dokumentacji, co może wpłynąć na ostateczną wycenę.",
    },
    {
      q: "Jak często przeprowadza się przeglądy instalacji we Wrocławiu?",
      a: "Przegląd gazowy jest wymagany co roku, a przegląd elektryczny co pięć lat — dotyczy to wszystkich budynków we Wrocławiu, niezależnie od ich wieku i lokalizacji. Właściciel lub zarządca ponosi odpowiedzialność za terminowe wykonanie i przechowywanie protokołów.",
    },
    {
      q: "Czy budynki przedwojenne we Wrocławiu wymagają specjalnych przeglądów?",
      a: "Zabudowa sprzed 1945 roku, charakterystyczna dla wrocławskiego Śródmieścia, Biskupina czy Sępolna, często kryje oryginalne instalacje elektryczne z okresu międzywojennego. Specjalista musi uwzględnić specyfikę takich budynków przy protokołowaniu i ocenie ryzyka.",
    },
    {
      q: "Jak umówić przegląd instalacji we Wrocławiu bez zbędnego czekania?",
      a: "Platforma inspektomat.pl pozwala wysłać jedno zapytanie do wielu firm działających we Wrocławiu. Możesz porównać terminy, ceny i opinie, a wizytę umówić online — bez telefonów i wielotygodniowego oczekiwania.",
    },
  ],

  poznan: [
    {
      q: "Ile kosztuje przegląd elektryczny w Poznaniu?",
      a: "Ceny przeglądów elektrycznych w Poznaniu wynoszą przeciętnie 220–460 zł netto za mieszkanie. Na Starym Mieście i Jeżycach, gdzie dominują kamienice, wycena jest wyższa niż na blokowiskach Piątkowa czy Rataj ze względu na złożoność instalacji.",
    },
    {
      q: "Czy właściciel mieszkania w Poznaniu może być ukarany za brak przeglądu?",
      a: "Tak. Właściciel lub zarządca budynku w Poznaniu, który nie przeprowadza wymaganych przeglądów instalacji, narażony jest na mandat oraz odpowiedzialność cywilną w razie awarii lub szkody. Coroczny przegląd gazowy i pięcioletni elektryczny to obowiązek wynikający z Prawa budowlanego.",
    },
    {
      q: "Jak stan instalacji gazowych różni się w kamienicach Jeżyc i w blokach na Ratajach?",
      a: "Kamienice Jeżyc często posiadają kilkudziesięcioletnie instalacje gazowe wymagające uszczelnienia lub wymiany rur. Bloki na Ratajach i Piątkowie, budowane masowo w latach 70–80., mają nowsze instalacje, ale wymagają regularnej kontroli ze względu na wiek i intensywne użytkowanie.",
    },
    {
      q: "Jak przez internet zamówić przegląd instalacji w Poznaniu?",
      a: "Wystarczy wypełnić formularz na inspektomat.pl — zgłoszenie trafi do certyfikowanych firm obsługujących Poznań i okolice. Porównujesz oferty w jednym miejscu i wybierasz wykonawcę dopasowanego do Twojego budynku.",
    },
  ],

  lodz: [
    {
      q: "Ile kosztuje przegląd instalacji w Łodzi?",
      a: "W Łodzi przegląd elektryczny kosztuje zazwyczaj 220–450 zł netto, a gazowy 130–290 zł netto za lokal. Zabytkowe kamienice i lofty poprzemysłowe wymagają często rozszerzonego protokołu ze względu na specyfikę historycznej instalacji.",
    },
    {
      q: "Czy przegląd instalacji gazowej w łódzkich kamienicach jest obowiązkowy?",
      a: "Tak — coroczny przegląd gazowy jest obowiązkowy we wszystkich budynkach w Łodzi wyposażonych w instalację gazową, bez wyjątku. Dotyczy to zarówno XIX-wiecznych kamienic Śródmieścia i Bałut, jak i bloków na Górnej czy Widzewie.",
    },
    {
      q: "Jakie szczególne zagrożenia wynikają ze stanu instalacji w łódzkich kamienicach fabrycznych?",
      a: "Łódzkie kamienice i budynki poprzemysłowe przekształcone w lofty nierzadko zachowują oryginalne instalacje elektryczne z przełomu XIX i XX wieku. Brak modernizacji przekłada się na realne ryzyko pożarowe, dlatego przed zakupem lub wynajmem warto zlecić rzetelny przegląd z pełną dokumentacją.",
    },
    {
      q: "Jak znaleźć elektryka lub gazownika z certyfikatem w Łodzi?",
      a: "Platforma inspektomat.pl gromadzi oferty certyfikowanych firm z Łodzi. Jedno zapytanie trafia do wielu wykonawców jednocześnie — możesz porównać ceny, terminy i opinie bez samodzielnego poszukiwania.",
    },
  ],

  gdansk: [
    {
      q: "Ile kosztuje przegląd instalacji w Gdańsku?",
      a: "Ceny przeglądów elektrycznych w Gdańsku to zazwyczaj 250–500 zł netto, a gazowych 140–320 zł netto za lokal. Lokalizacja w pobliżu morza nie zmienia stawki, ale może wpływać na zakres zaleceń poreglądowych ze względu na korozyjne warunki.",
    },
    {
      q: "Dlaczego przeglądy instalacji w Gdańsku są szczególnie ważne?",
      a: "Nadmorski klimat — wysoka wilgotność i zasolenie powietrza — przyspiesza korozję rur gazowych i przewodów elektrycznych w gdańskich budynkach. Regularne przeglądy pozwalają wychwycić oznaki korozji zanim dojdzie do awarii lub wycieku.",
    },
    {
      q: "Czy odbudowane kamienice Gdańskiego Starego Miasta wymagają szczególnej uwagi?",
      a: "Tak. Budynki odbudowane po 1945 roku na terenie Starego Miasta i wokół Długiego Targu mają instalacje projektowane w różnych standardach i nie zawsze były modernizowane. Przegląd elektryczny lub gazowy wskaże ewentualne usterki i potrzebę aktualizacji.",
    },
    {
      q: "Jak szybko umówić przegląd instalacji w Trójmieście?",
      a: "Przez inspektomat.pl obsługujemy nie tylko Gdańsk, ale też Sopot i okolice Pruszcza Gdańskiego. Jedno zapytanie online trafia do kilku firm — porównujesz terminy i ceny bez zbędnego dzwonienia.",
    },
  ],

  katowice: [
    {
      q: "Ile kosztuje przegląd instalacji gazowej w Katowicach?",
      a: "W Katowicach przegląd gazowy kosztuje zazwyczaj 130–300 zł netto za lokal. W familokach i kamienicach ze Śródmieścia ceny mogą być nieco wyższe ze względu na starszą infrastrukturę i bardziej skomplikowane instalacje gazowe.",
    },
    {
      q: "Czy w śląskich familokach obowiązuje coroczny przegląd gazowy?",
      a: "Tak — coroczny przegląd instalacji gazowej jest obowiązkowy w każdym budynku, w tym w familokach i domach robotniczych typowych dla Katowic i aglomeracji śląskiej. Gęstość zabudowy i tradycja ogrzewania gazowego sprawiają, że regularna kontrola jest tu szczególnie istotna dla bezpieczeństwa.",
    },
    {
      q: "Jak wiek i typ zabudowy w Katowicach wpływa na stan instalacji?",
      a: "Familoki z przełomu XIX i XX wieku oraz bloki z lat 60–80. to dominująca zabudowa w wielu dzielnicach Katowic. W obu przypadkach instalacje elektryczne mogą być przestarzałe, a gazowe wyeksploatowane. Protokół z przeglądu wskazuje konkretne zagrożenia i zalecany zakres napraw.",
    },
    {
      q: "Jak zamówić przegląd instalacji w Katowicach i aglomeracji?",
      a: "Platforma inspektomat.pl obsługuje Katowice oraz sąsiednie miasta aglomeracji górnośląskiej. Wystarczy jedno zgłoszenie online, by otrzymać oferty od kilku certyfikowanych firm — bez konieczności samodzielnego szukania wykonawcy.",
    },
  ],

  szczecin: [
    {
      q: "Ile kosztuje przegląd elektryczny w Szczecinie?",
      a: "Ceny przeglądów elektrycznych w Szczecinie wynoszą zazwyczaj 230–480 zł netto za lokal. Secesyjne kamienice centrum bywają droższe w obsłudze niż bloki na Prawobrzeżu czy Zdrójach ze względu na starszą i bardziej rozbudowaną instalację.",
    },
    {
      q: "Jak morski klimat Szczecina wpływa na instalacje techniczne budynków?",
      a: "Nadmorska wilgoć i zmienne temperatury przyspieszają korozję rur gazowych oraz degradację izolacji przewodów elektrycznych w szczecińskich budynkach. To jeden z powodów, dla których właściciele nieruchomości w Szczecinie powinni traktować przeglądy priorytetowo.",
    },
    {
      q: "Czy secesyjne kamienice Szczecina wymagają specjalistycznych przeglądów?",
      a: "Historyczne kamienice Pogodna, Niebuszewa i centrum Szczecina nierzadko zachowują oryginalne lub wielokrotnie przerabiane instalacje elektryczne. Dobry przegląd elektryk oceni stan izolacji, stan tablicy i sposób prowadzenia przewodów, wskazując zakres niezbędnych prac.",
    },
    {
      q: "Jak umówić przegląd instalacji w Szczecinie online?",
      a: "Na inspektomat.pl wypełniasz jeden formularz, a oferty od certyfikowanych firm szczecińskich trafiają do Ciebie. Porównujesz terminy, ceny i opinie — bez telefonów i szukania po ogłoszeniach.",
    },
  ],

  lublin: [
    {
      q: "Ile kosztuje przegląd instalacji w Lublinie?",
      a: "W Lublinie przeglądy elektryczne kosztują zazwyczaj 200–400 zł netto, a gazowe 120–260 zł netto za lokal. Starsze budynki w okolicach Starego Miasta i Śródmieścia mogą wymagać szerszej diagnostyki niż typowe bloki LSM czy Czub.",
    },
    {
      q: "Jakie są obowiązki właściciela mieszkania w Lublinie w zakresie przeglądów?",
      a: "Właściciel lub zarządca nieruchomości w Lublinie jest zobowiązany do przeprowadzenia corocznego przeglądu gazowego i co najmniej pięcioletniego elektrycznego. Nieprzeprowadzenie przeglądu grozi mandatem, a w razie awarii — problemami z ubezpieczeniem i odpowiedzialnością cywilną.",
    },
    {
      q: "Jak bloki LSM różnią się od kamienic Śródmieścia pod względem stanu instalacji?",
      a: "Bloki na LSM i Czubach to zabudowa z lat 70–80., w której instalacje elektryczne są nowsze, lecz często niemodernizonwe od dziesięcioleci. Kamienice wokół Starego Miasta Lublina mogą natomiast posiadać instalacje pamiętające lata 50–60. ubiegłego wieku wymagające oceny przez uprawnionego elektryka.",
    },
    {
      q: "Jak zamówić przegląd instalacji w Lublinie przez internet?",
      a: "Zgłoszenie przez inspektomat.pl trafia do kilku certyfikowanych firm działających w Lublinie. Możesz porównać ceny i terminy, sprawdzić opinie i wybrać wykonawcę — wszystko bez wychodzenia z domu.",
    },
  ],

  bydgoszcz: [
    {
      q: "Ile kosztuje przegląd instalacji elektrycznej w Bydgoszczy?",
      a: "Ceny przeglądów elektrycznych w Bydgoszczy wynoszą zazwyczaj 200–400 zł netto za lokal. Kamienice Śródmieścia i okolic Brdy bywają droższe w obsłudze niż bloki na Fordonie czy Wyżynach ze względu na bardziej skomplikowane i starsze instalacje.",
    },
    {
      q: "Czy przegląd gazowy jest obowiązkowy w starych kamienicach Bydgoszczy?",
      a: "Tak — coroczny przegląd gazowy obowiązuje we wszystkich budynkach wyposażonych w instalację gazową, bez wyjątku. W nadkanałowych kamienicach Bydgoszczy, gdzie instalacje mogą mieć kilkadziesiąt lat, regularna kontrola jest szczególnie istotna dla bezpieczeństwa mieszkańców.",
    },
    {
      q: "Jakie problemy z instalacją elektryczną są typowe w bydgoskich kamienicach?",
      a: "Kamienice w centrum Bydgoszczy i Okolu często posiadają aluminiowe przewody i przestarzałe tablice bezpiecznikowe. Tego rodzaju instalacje są sprawne, ale stanowią podwyższone ryzyko pożarowe — uprawniony elektryk po przeglądzie wskaże, czy konieczna jest wymiana czy wystarczy modernizacja.",
    },
    {
      q: "Jak znaleźć elektryka lub gazownika w Bydgoszczy?",
      a: "Platforma inspektomat.pl skupia certyfikowanych wykonawców z Bydgoszczy i okolic. Wypełniasz jedno zapytanie, dostajesz oferty od kilku firm, porównujesz i wybierasz — bez szukania po ogłoszeniach.",
    },
  ],

  bialystok: [
    {
      q: "Ile kosztuje przegląd instalacji gazowej w Białymstoku?",
      a: "Ceny przeglądów gazowych w Białymstoku wynoszą zazwyczaj 120–260 zł netto za lokal. Ze względu na intensywne ogrzewanie charakterystyczne dla podlaskiego klimatu, stan instalacji gazowej warto sprawdzać regularnie — jeszcze przed sezonem grzewczym.",
    },
    {
      q: "Dlaczego przeglądy gazowe są szczególnie ważne w Białymstoku?",
      a: "Surowe zimy w Białymstoku powodują, że instalacje gazowe pracują intensywnie przez długą część roku. Przyspiesza to zużycie rur i uszczelek, przez co coroczny przegląd nabiera szczególnego znaczenia — pozwala wychwycić nieszczelności zanim staną się zagrożeniem.",
    },
    {
      q: "Czy bloki z wielkiej płyty w Białymstoku wymagają modernizacji instalacji?",
      a: "Osiedla z wielkiej płyty, takie jak Słoneczny Stok, Piasta czy Mickiewicza, to typowa zabudowa białostocka z lat 70–80. Instalacje elektryczne w tych budynkach mogą wymagać wymiany ze względu na wiek, a instalacje gazowe — corocznej kontroli stanu technicznego.",
    },
    {
      q: "Jak zamówić przegląd instalacji w Białymstoku?",
      a: "Przez inspektomat.pl wyślesz jedno zgłoszenie do kilku firm obsługujących Białystok i okolice (Wasilków, Supraśl, Łapy). Porównujesz oferty i wybierasz termin bez zbędnych telefonów.",
    },
  ],

  gdynia: [
    {
      q: "Ile kosztuje przegląd elektryczny w Gdyni?",
      a: "Przeglądy elektryczne w Gdyni kosztują zazwyczaj 230–460 zł netto za lokal. Modernistyczne kamienice z lat 30. w Śródmieściu mogą wymagać bardziej szczegółowego protokołu niż bloki na Chyloni, co wpływa na czas i cenę przeglądu.",
    },
    {
      q: "Jak sąsiedztwo morza wpływa na instalacje techniczne w gdyńskich budynkach?",
      a: "Port i bliskość Zatoki Gdańskiej sprawiają, że instalacje elektryczne i gazowe w Gdyni są bardziej narażone na wilgoć i zasolone powietrze niż w miastach śródlądowych. Coroczny przegląd pozwala wychwycić korozję na wczesnym etapie i uniknąć kosztownych awarii.",
    },
    {
      q: "Czy modernistyczne kamienice z lat 30. w Gdyni wymagają specjalnych przeglądów?",
      a: "Śródmiejskie kamienice Gdyni z okresu budowy miasta jako portu morskiego mają unikatowy charakter, ale też kilkudziesięcioletnie instalacje elektryczne. Przegląd przez uprawnionego elektryka oceni ich aktualny stan i zgodność z wymaganiami bezpieczeństwa.",
    },
    {
      q: "Jak umówić przegląd instalacji w Gdyni lub Trójmieście?",
      a: "Platforma inspektomat.pl obsługuje Gdynię oraz sąsiednie miejscowości: Rumię, Redę, Wejherowo i okolice. Wystarczy jedno zgłoszenie online — otrzymujesz oferty od kilku firm i wybierasz najlepszą.",
    },
  ],

  czestochowa: [
    {
      q: "Ile kosztuje przegląd instalacji w Częstochowie?",
      a: "Ceny przeglądów elektrycznych w Częstochowie to zazwyczaj 190–380 zł netto, a gazowych 110–240 zł netto za lokal. Na dużych osiedlach blokowych jak Tysiąclecie i Raków stawki bywają nieco niższe niż przy zabudowie kamienicowej centrum.",
    },
    {
      q: "Czy właściciel mieszkania w Częstochowie może być pociągnięty do odpowiedzialności za brak przeglądu?",
      a: "Tak. Właściciel lub zarządca nieruchomości w Częstochowie ma ustawowy obowiązek przeprowadzania regularnych przeglądów instalacji. Zaniedbanie tego obowiązku może skutkować mandatem, a w przypadku awarii — odmową wypłaty odszkodowania przez ubezpieczyciela.",
    },
    {
      q: "W jakiej kondycji są instalacje w blokach na osiedlu Tysiąclecie w Częstochowie?",
      a: "Bloki na Tysiącleciu i Rakowie powstawały w latach 60–80. Instalacje elektryczne w tych budynkach liczą sobie 40–60 lat i mogą wymagać oceny stanu technicznego lub modernizacji tablicy rozdzielczej. Coroczny przegląd gazowy to natomiast bezwzględny wymóg prawny.",
    },
    {
      q: "Jak zamówić przegląd instalacji w Częstochowie?",
      a: "Wejdź na inspektomat.pl, wypełnij formularz i poczekaj na oferty od certyfikowanych firm z Częstochowy. Jedno zapytanie trafia do kilku wykonawców — porównujesz i decydujesz bez zbędnych telefonów.",
    },
  ],

  radom: [
    {
      q: "Ile kosztuje przegląd instalacji gazowej w Radomiu?",
      a: "Przeglądy gazowe w Radomiu kosztują zazwyczaj 110–240 zł netto za lokal. Ceny elektrycznych wahają się od 190 do 370 zł netto. Stawki zależą od metrażu, liczby punktów pomiarowych i aktualnego stanu instalacji.",
    },
    {
      q: "Jak często należy przeprowadzać przeglądy instalacji w Radomiu?",
      a: "W Radomiu obowiązują te same terminy co w całej Polsce: przegląd gazowy co roku, elektryczny co pięć lat. Właściciel lub zarządca budynku odpowiada za terminowe zlecenie i przechowywanie protokołów przeglądowych.",
    },
    {
      q: "Jaki jest stan instalacji w radomskich blokach z lat 70.?",
      a: "Osiedla Gołębiów, Borki i Planty to zabudowa z okresu PRL z instalacjami, które w wielu przypadkach nie były modernizowane od kilkudziesięciu lat. Typowe usterki to zużyte tablice bezpiecznikowe, aluminiowe przewody oraz stare rury gazowe wymagające oceny technicznej.",
    },
    {
      q: "Jak umówić przegląd instalacji w Radomiu przez internet?",
      a: "Na inspektomat.pl wystarczy jedno zgłoszenie, by oferty od certyfikowanych firm radomskich trafiły do Ciebie. Możesz wybrać termin i wykonawcę bez szukania po ogłoszeniach i portalach.",
    },
  ],

  torun: [
    {
      q: "Ile kosztuje przegląd elektryczny w Toruniu?",
      a: "Ceny przeglądów elektrycznych w Toruniu wynoszą zazwyczaj 200–400 zł netto za lokal. Zabytkowe kamienice Starego Miasta i Bydgoskiego Przedmieścia wymagają zwykle bardziej szczegółowego protokołu niż bloki na Rubinkowie czy Wrzosach.",
    },
    {
      q: "Dlaczego przeglądy instalacji w toruńskich zabytkach mają szczególne znaczenie?",
      a: "Toruńska Starówka wpisana jest na Listę UNESCO. Uszkodzona instalacja elektryczna lub wyciek gazu w zabytkowym budynku mogą prowadzić do nieodwracalnych szkód w historycznej substancji budowlanej. Regularny przegląd to tu konieczność zarówno prawna, jak i wynikająca z odpowiedzialności za dziedzictwo.",
    },
    {
      q: "Jak często wykonuje się przeglądy instalacji gazowych w Toruniu?",
      a: "Coroczny przegląd gazowy obowiązuje wszystkich właścicieli i zarządców budynków wyposażonych w instalację gazową w Toruniu. Dotyczy to zarówno gotyckich kamienic centrum, jak i bloków z PRL na Rubinkowie i Wrzosach.",
    },
    {
      q: "Jak znaleźć certyfikowanego elektryka lub gazownika w Toruniu?",
      a: "Platforma inspektomat.pl skupia firmy obsługujące Toruń i okolice (Grudziądz, Chełmno, okoliczne gminy). Jedno zapytanie online trafia do kilku wykonawców — porównujesz i wybierasz bez zbędnego szukania.",
    },
  ],

  rzeszow: [
    {
      q: "Ile kosztuje przegląd instalacji w Rzeszowie?",
      a: "Ceny przeglądów elektrycznych w Rzeszowie wynoszą zazwyczaj 200–400 zł netto, a gazowych 120–250 zł netto za lokal. Dynamiczny rozwój miasta oznacza duży udział nowego budownictwa, choć starsze budynki centrum wymagają równie starannej kontroli.",
    },
    {
      q: "Czy nowe budynki w Rzeszowie wymagają przeglądów instalacji?",
      a: "Tak. Obowiązek przeglądowy wynika z Prawa budowlanego i dotyczy wszystkich budynków — niezależnie od ich wieku. Nawet nowoczesne osiedla deweloperskie potrzebują corocznych przeglądów gazowych i cyklicznych elektrycznych, bo usterki mogą wystąpić w każdym budynku.",
    },
    {
      q: "Dlaczego Rzeszów jako szybko rosnące miasto generuje szczególne wyzwania przeglądowe?",
      a: "Gwałtowny przyrost nowych osiedli oznacza, że deweloperzy i wspólnoty muszą zadbać o systematyczne przeglądy od samego początku eksploatacji budynku. Jednocześnie starsze części miasta (Staroniwa, Centrum) mają instalacje liczące 30–50 lat wymagające oceny.",
    },
    {
      q: "Jak zamówić przegląd instalacji w Rzeszowie?",
      a: "Przez inspektomat.pl wyślesz zapytanie do kilku firm certyfikowanych działających w Rzeszowie i okolicach (Łańcut, Głogów Małopolski, Tyczyn). Oferty przychodzą do Ciebie — bez zbędnego szukania.",
    },
  ],

  kielce: [
    {
      q: "Ile kosztuje przegląd instalacji elektrycznej w Kielcach?",
      a: "Przeglądy elektryczne w Kielcach kosztują zazwyczaj 190–380 zł netto za lokal. Na osiedlu KSM stawki bywają nieco niższe niż w przypadku kamienic Śródmieścia ze względu na standardowość i powtarzalność instalacji blokowych.",
    },
    {
      q: "Czy coroczny przegląd gazowy obowiązuje w kieleckich blokach?",
      a: "Tak — coroczny przegląd instalacji gazowej dotyczy każdego budynku wyposażonego w gaz, w tym bloków na KSM, Na Stoku i Czarnowie. Właściciel mieszkania odpowiada za terminowe przeprowadzenie przeglądu i przechowywanie protokołu.",
    },
    {
      q: "Jak wygląda stan instalacji w blokach KSM w Kielcach?",
      a: "Osiedle KSM to zabudowa z lat 60–80., gdzie instalacje elektryczne mogą wymagać modernizacji lub wymiany tablicy rozdzielczej. Instalacje gazowe, przy regularnych przeglądach, są zazwyczaj sprawne, ale coroczna kontrola wskaże ewentualne nieszczelności lub zużycie elementów.",
    },
    {
      q: "Jak umówić przegląd instalacji w Kielcach?",
      a: "Na inspektomat.pl wysyłasz jedno zapytanie do kilku certyfikowanych firm działających w Kielcach. Otrzymujesz oferty, porównujesz i wybierasz najwygodniejszy termin — wszystko online.",
    },
  ],

  gliwice: [
    {
      q: "Ile kosztuje przegląd gazowy w Gliwicach?",
      a: "Przeglądy gazowe w Gliwicach kosztują zazwyczaj 120–270 zł netto za lokal. Kamienice śródmiejskie i familoki bywają nieco droższe w obsłudze niż standardowe bloki ze względu na starszą instalację i konieczność szczegółowego protokołu.",
    },
    {
      q: "Czy familoki w Gliwicach podlegają obowiązkowi przeglądu instalacji?",
      a: "Tak — coroczny przegląd gazowy i pięcioletni elektryczny obowiązują we wszystkich budynkach, w tym w historycznych familokach. Starzejąca się infrastruktura techniczna tych budynków sprawia, że regularna kontrola ma szczególne znaczenie dla bezpieczeństwa.",
    },
    {
      q: "Jak industrialna przeszłość Gliwic wpływa na stan instalacji w budynkach?",
      a: "Sąsiedztwo zakładów przemysłowych przez dekady narażało gliwickie budynki na drgania, zanieczyszczenia i wahania temperatury, co przyspiesza zużycie instalacji technicznych. W kamienicach centrum i familokach problem dotyczy szczególnie instalacji elektrycznej ze starą izolacją.",
    },
    {
      q: "Jak zamówić przegląd instalacji w Gliwicach lub aglomeracji?",
      a: "Platforma inspektomat.pl obsługuje Gliwice oraz sąsiednie miejscowości: Knurów, Pyskowice, Zabrze. Jedno zapytanie online wystarczy, by porównać oferty kilku certyfikowanych firm.",
    },
  ],

  zabrze: [
    {
      q: "Ile kosztuje przegląd elektryczny w Zabrzu?",
      a: "Ceny przeglądów elektrycznych w Zabrzu wynoszą zazwyczaj 180–360 zł netto za lokal. W historycznych familokach, gdzie instalacje są starsze i bardziej złożone, wycena bywa wyższa niż w standardowych blokach.",
    },
    {
      q: "Jak często trzeba przeprowadzać przeglądy instalacji gazowej w zabrzańskich familokach?",
      a: "Coroczny przegląd instalacji gazowej jest obowiązkowy we wszystkich budynkach w Zabrzu wyposażonych w gaz, w tym w historycznych familokach górniczych. Gęsta zabudowa i tradycja ogrzewania gazowego sprawiają, że brak przeglądu stanowi realne zagrożenie.",
    },
    {
      q: "Jakie usterki są typowe w zabrskich budynkach robotniczych?",
      a: "Familoki z przełomu XIX i XX wieku oraz domy robotnicze w Zabrzu często posiadają instalacje elektryczne wielokrotnie przerabiane bez pełnej dokumentacji oraz zużyte instalacje gazowe. Przegląd pozwala ocenić stan i zaplanować modernizację z wyprzedzeniem.",
    },
    {
      q: "Jak znaleźć wykonawcę przeglądów instalacji w Zabrzu i okolicach?",
      a: "Przez inspektomat.pl wyślesz jedno zapytanie do firm obsługujących Zabrze, Gliwice, Bytom i całą aglomerację. Porównujesz oferty i wybierasz termin bez szukania po ogłoszeniach.",
    },
  ],

  olsztyn: [
    {
      q: "Ile kosztuje przegląd instalacji w Olsztynie?",
      a: "Ceny przeglądów elektrycznych w Olsztynie wynoszą zazwyczaj 190–380 zł netto, a gazowych 110–240 zł netto za lokal. Zabytkowe budynki centrum i Starego Miasta mogą wymagać bardziej szczegółowego protokołu.",
    },
    {
      q: "Dlaczego przegląd gazowy w Olsztynie jest szczególnie ważny zimą?",
      a: "Mroźne zimy charakterystyczne dla klimatu warmińskiego intensywnie obciążają instalacje grzewcze i gazowe w olsztyńskich budynkach. Coroczny przegląd instalacji gazowej — najlepiej przed sezonem grzewczym — pozwala wychwycić nieszczelności zanim staną się poważnym zagrożeniem.",
    },
    {
      q: "Czy bloki PRL na Jarotach i Kortowie w Olsztynie wymagają modernizacji instalacji?",
      a: "Blokowiska z lat 70–80. na Jarotach, Podleśnej i Kortowie mają instalacje elektryczne liczące 40–50 lat. W wielu przypadkach konieczna jest wymiana tablicy rozdzielczej lub przewodów. Coroczny przegląd gazowy jest natomiast bezwzględnym wymogiem prawnym niezależnie od wieku budynku.",
    },
    {
      q: "Jak zamówić przegląd instalacji w Olsztynie?",
      a: "Na inspektomat.pl jedno zgłoszenie trafia do certyfikowanych firm obsługujących Olsztyn i okoliczne gminy: Dywity, Stawigudę, Barczewo. Porównujesz oferty i wybierasz najwygodniejszy termin.",
    },
  ],

  "bielsko-biala": [
    {
      q: "Ile kosztuje przegląd instalacji w Bielsku-Białej?",
      a: "Ceny przeglądów elektrycznych w Bielsku-Białej wynoszą zazwyczaj 190–380 zł netto, a gazowych 110–240 zł netto za lokal. Kamienice historycznego centrum (dawne Bielsko i Biała) mogą wymagać bardziej szczegółowego protokołu ze względu na wiek instalacji.",
    },
    {
      q: "Jak górskie położenie Bielska-Białej wpływa na stan instalacji technicznych?",
      a: "Zróżnicowane temperatury i intensywne opady charakterystyczne dla pogórza beskidzkiego przyspieszają zużycie instalacji gazowych i elektrycznych. Właściciele budynków w Bielsku-Białej powinni planować regularne przeglądy z uwzględnieniem tych warunków klimatycznych.",
    },
    {
      q: "Czy kamienice z połączenia dawnego Bielska i Białej wymagają szczególnej uwagi?",
      a: "Kamienice centrum Bielska-Białej z przełomu XIX i XX wieku łączą pruski i austro-węgierski charakter architektoniczny. Instalacje w tych budynkach były wielokrotnie modernizowane w różnych standardach — rzetelny przegląd elektryczny pozwoli ocenić aktualny stan i bezpieczeństwo.",
    },
    {
      q: "Jak umówić przegląd instalacji w Bielsku-Białej?",
      a: "Platforma inspektomat.pl obsługuje Bielsko-Białą i okolice, w tym Czechowice-Dziedzice, Skoczów i Andrychów. Wystarczy jedno online zgłoszenie, by otrzymać oferty od certyfikowanych firm.",
    },
  ],

  rybnik: [
    {
      q: "Ile kosztuje przegląd instalacji w Rybniku?",
      a: "Przeglądy elektryczne w Rybniku kosztują zazwyczaj 180–360 zł netto, a gazowe 110–230 zł netto za lokal. W familokach i starszych budynkach robotniczych wycena może być nieco wyższa ze względu na skomplikowaną instalację.",
    },
    {
      q: "Czy budynki pokopalniane w Rybniku wymagają szczególnych przeglądów elektrycznych?",
      a: "Starsze domy robotnicze i familoki Rybnika, związane z tradycją górniczą regionu, często posiadają wielokrotnie przerabiane instalacje elektryczne bez kompleksowej dokumentacji. Rzetelny przegląd wskazuje aktualny stan i ewentualny zakres modernizacji.",
    },
    {
      q: "Jak często trzeba robić przegląd gazowy w Rybniku?",
      a: "Coroczny przegląd instalacji gazowej obowiązuje wszystkich właścicieli i zarządców budynków wyposażonych w gaz w Rybniku — zarówno familoków, jak i bloków i nowych budynków deweloperskich. Brak ważnego protokołu to naruszenie Prawa budowlanego.",
    },
    {
      q: "Jak zamówić przegląd instalacji w Rybniku lub aglomeracji?",
      a: "Przez inspektomat.pl wyślesz jedno zapytanie do firm obsługujących Rybnik, Jastrzębie-Zdrój, Żory i okolice. Otrzymujesz oferty od kilku wykonawców i wybierasz najlepszą.",
    },
  ],

  tychy: [
    {
      q: "Ile kosztuje przegląd instalacji w Tychach?",
      a: "Ceny przeglądów elektrycznych w Tychach wynoszą zazwyczaj 180–360 zł netto, a gazowych 110–230 zł netto za lokal. Jednolita zabudowa osiedlowa ułatwia standaryzację wycen w porównaniu do miast z bardzo zróżnicowanym zasobem mieszkaniowym.",
    },
    {
      q: "Dlaczego instalacje w tychowskich blokach z lat 50–70. wymagają szczególnej uwagi?",
      a: "Tychy zostały zbudowane od podstaw w latach 50. ubiegłego wieku jako miasto-ogród. Bloki oznaczone literami (A–G) i kolejne etapy zabudowy liczą dziś 50–70 lat. Instalacje elektryczne z tego okresu mogą wymagać oceny lub wymiany, a gazowe — corocznej obowiązkowej kontroli.",
    },
    {
      q: "Czy przegląd gazowy jest wymagany w każdym tyskim bloku?",
      a: "Tak — coroczny przegląd instalacji gazowej obowiązuje we wszystkich budynkach Tychów wyposażonych w gaz. Zarządca lub właściciel mieszkania odpowiada za terminowe zlecenie i przechowywanie protokołu przeglądowego.",
    },
    {
      q: "Jak umówić przegląd instalacji w Tychach online?",
      a: "Na inspektomat.pl wystarczy jedno zgłoszenie, by otrzymać oferty od firm obsługujących Tychy i okolice (Mikołów, Bieruń, Lędziny). Porównujesz, wybierasz i umawiasz się bez telefonów.",
    },
  ],

  "dabrowa-gornicza": [
    {
      q: "Ile kosztuje przegląd instalacji elektrycznej w Dąbrowie Górniczej?",
      a: "Przeglądy elektryczne w Dąbrowie Górniczej kosztują zazwyczaj 180–360 zł netto za lokal. W starszych budynkach w okolicach Ząbkowic czy Strzemieszyce ceny mogą być nieco wyższe ze względu na wiek i złożoność instalacji.",
    },
    {
      q: "Dlaczego aktualny protokół przeglądowy jest ważny dla ubezpieczenia nieruchomości w Dąbrowie Górniczej?",
      a: "Ubezpieczyciele coraz częściej wymagają aktualnych protokołów przeglądów instalacji jako warunek wypłaty odszkodowania. Właściciele nieruchomości w Dąbrowie Górniczej powinni zadbać o terminowe przeglądy nie tylko ze względu na Prawo budowlane, ale i ochronę ubezpieczeniową.",
    },
    {
      q: "Jaki jest stan instalacji w blokach Dąbrowy Górniczej z okresu PRL?",
      a: "Dzielnice takie jak Łękinia, Gołonóg czy Ząbkowice zdominowane są przez zabudowę wielorodzinną z lat 60–80. Instalacje elektryczne w tych budynkach mogą wymagać modernizacji, a roczny przegląd gazowy jest obowiązkowy niezależnie od stanu instalacji.",
    },
    {
      q: "Jak zamówić przegląd instalacji w Dąbrowie Górniczej?",
      a: "Platforma inspektomat.pl obsługuje Dąbrowę Górniczą i sąsiednie miejscowości: Będzin, Czeladź, Sławków. Jedno zapytanie online trafia do kilku certyfikowanych firm — porównujesz i decydujesz.",
    },
  ],

  plock: [
    {
      q: "Ile kosztuje przegląd instalacji w Płocku?",
      a: "Ceny przeglądów elektrycznych w Płocku wynoszą zazwyczaj 180–360 zł netto, a gazowych 110–240 zł netto za lokal. Zabytkowe budynki centrum przy Wzgórzu Tumskim mogą wymagać bardziej szczegółowego protokołu.",
    },
    {
      q: "Czy przegląd gazowy jest obowiązkowy w płockich blokach?",
      a: "Tak — coroczny przegląd instalacji gazowej obowiązuje wszystkich właścicieli i zarządców budynków wyposażonych w gaz w Płocku. Dotyczy to zarówno kamienic centrum, jak i bloków na Podolszycach, Kostrogaju czy Skarpie.",
    },
    {
      q: "Jak industrialny rozwój Płocka wpłynął na stan instalacji w budynkach?",
      a: "Intensywny rozwój przemysłowy Płocka w latach 60–80. przełożył się na masową budowę bloków mieszkalnych, których instalacje techniczne liczą dziś 40–60 lat. W wielu budynkach tego okresu konieczna jest ocena lub wymiana instalacji elektrycznej.",
    },
    {
      q: "Jak znaleźć firmę przeglądową w Płocku i okolicach?",
      a: "Przez inspektomat.pl wyślesz jedno zapytanie do certyfikowanych firm obsługujących Płock i okoliczne gminy (Bielsk, Stara Biała, Drobin). Porównujesz oferty i wybierasz termin online.",
    },
  ],

  opole: [
    {
      q: "Ile kosztuje przegląd instalacji w Opolu?",
      a: "Ceny przeglądów elektrycznych w Opolu wynoszą zazwyczaj 180–360 zł netto, a gazowych 110–230 zł netto za lokal. Historyczne kamienice centrum, w tym okolice Wyspy Pasieka, mogą wymagać szerszego zakresu kontroli.",
    },
    {
      q: "Jak często przeprowadza się przeglądy instalacji w opolskich budynkach?",
      a: "W Opolu obowiązują identyczne wymogi jak w całej Polsce: coroczny przegląd instalacji gazowej i pięcioletni elektrycznej. Zarządca lub właściciel budynku odpowiada za terminowe zlecenie i przechowywanie protokołów.",
    },
    {
      q: "Dlaczego zabytkowe kamienice Opola wymagają szczególnej dbałości o stan instalacji?",
      a: "Historyczna zabudowa centrum Opola i okolic Wyspy Pasieka kryje instalacje z różnych epok. Regularne przeglądy pozwalają ocenić ich stan, a ewentualne naprawy chronią zarówno mieszkańców, jak i wartość historyczną substancji budowlanej.",
    },
    {
      q: "Jak zamówić przegląd instalacji w Opolu?",
      a: "Platforma inspektomat.pl skupia certyfikowanych wykonawców z Opola i okolic (Prószków, Komprachcice, Tarnów Opolski). Jedno zgłoszenie online wystarczy, by porównać oferty i wybrać termin.",
    },
  ],

  elblag: [
    {
      q: "Ile kosztuje przegląd elektryczny w Elblągu?",
      a: "Ceny przeglądów elektrycznych w Elblągu wynoszą zazwyczaj 180–350 zł netto za lokal. Odbudowane bloki powojennego Śródmieścia i zabudowa Zatorza to typowe obiekty, gdzie koszt mieści się w standardowych widełkach cenowych.",
    },
    {
      q: "Jak wilgotny klimat Elbląga wpływa na instalacje techniczne?",
      a: "Bliskość Zalewu Wiślanego i wysoka wilgotność powietrza przyspieszają korozję rur gazowych i degradację izolacji przewodów elektrycznych w elbląskich budynkach. Właściciele nieruchomości powinni planować regularne przeglądy z uwzględnieniem tych warunków.",
    },
    {
      q: "Czy powojenne bloki Elbląga wymagają aktualizacji instalacji elektrycznej?",
      a: "Elbląg został odbudowany po zniszczeniach 1945 roku, a dominująca zabudowa blokowa z lat 50–70. dobiegła lub przekroczyła 50–70 lat. Instalacje elektryczne z tego okresu mogą wymagać oceny lub wymiany tablicy i przewodów.",
    },
    {
      q: "Jak zamówić przegląd instalacji w Elblągu?",
      a: "Na inspektomat.pl jedno zgłoszenie trafia do certyfikowanych firm obsługujących Elbląg i okolice (Malbork, Braniewo, Pasłęk). Porównujesz oferty i umawiasz się online.",
    },
  ],

  walbrzych: [
    {
      q: "Ile kosztuje przegląd elektryczny w Wałbrzychu?",
      a: "Ceny przeglądów elektrycznych w Wałbrzychu wynoszą zazwyczaj 180–360 zł netto za lokal. Starsze kamienice z okresu przemysłowego mogą wymagać obszerniejszego protokołu ze względu na archaiczną instalację aluminiową lub papierową.",
    },
    {
      q: "Dlaczego przeglądy elektryczne w wałbrzyskich budynkach są szczególnie ważne?",
      a: "Wiele budynków w Wałbrzychu pochodzi z okresu rozkwitu górnictwa węglowego — przełomu XIX i XX wieku oraz PRL. Instalacje elektryczne w tych obiektach mogą posiadać aluminiowe przewody lub papierową izolację, które stanowią realne zagrożenie pożarowe i wymagają wymiany.",
    },
    {
      q: "Jak transformacja postindustrialna Wałbrzycha wpływa na stan instalacji?",
      a: "Po zamknięciu kopalń wiele budynków mieszkalnych w Wałbrzychu nie przeszło gruntownych remontów. Instalacje techniczne w takich obiektach mogą być mocno wyeksploatowane, a regularne przeglądy pozwalają ocenić zakres koniecznych modernizacji przed kosztowną awarią.",
    },
    {
      q: "Jak zamówić przegląd instalacji w Wałbrzychu?",
      a: "Platforma inspektomat.pl obsługuje Wałbrzych i okolice (Świdnica, Dzierżoniów, Boguszów-Gorce). Jedno zapytanie online wystarczy, by porównać oferty certyfikowanych firm.",
    },
  ],

  "zielona-gora": [
    {
      q: "Ile kosztuje przegląd instalacji w Zielonej Górze?",
      a: "Ceny przeglądów elektrycznych w Zielonej Górze wynoszą zazwyczaj 180–360 zł netto, a gazowych 110–230 zł netto za lokal. Kamienice centrum z przełomu XIX i XX wieku mogą wymagać bardziej szczegółowego protokołu niż standardowe bloki na osiedlach.",
    },
    {
      q: "Jak często jest wymagany przegląd instalacji gazowej w Zielonej Górze?",
      a: "Coroczny przegląd instalacji gazowej obowiązuje wszystkich właścicieli i zarządców budynków wyposażonych w gaz w Zielonej Górze. Dotyczy to zarówno kamienic centrum, jak i bloków na Osiedlu Piastowskim, Łużyckim czy Słonecznym.",
    },
    {
      q: "Jak stan techniczny kamienic centrum Zielonej Góry wpływa na potrzeby przeglądowe?",
      a: "Kamienice centrum Zielonej Góry z przełomu XIX i XX wieku były wielokrotnie modernizowane w różnych standardach. Rzetelny przegląd elektryczny pozwala ocenić aktualny stan instalacji, a protokół z przeglądu gazowego jest wymogiem prawnym niezależnie od historii budynku.",
    },
    {
      q: "Jak zamówić przegląd instalacji w Zielonej Górze?",
      a: "Przez inspektomat.pl wyślesz jedno zapytanie do certyfikowanych firm obsługujących Zieloną Górę i okolice (Nowa Sól, Sulechów, Świebodzin). Otrzymujesz oferty i wybierasz najlepszą.",
    },
  ],

  koszalin: [
    {
      q: "Ile kosztuje przegląd instalacji elektrycznej w Koszalinie?",
      a: "Przeglądy elektryczne w Koszalinie kosztują zazwyczaj 180–350 zł netto za lokal. Bloki PRL stanowią dominującą zabudowę Koszalina, co pozwala na dość standardową wycenę w oparciu o metraż i liczbę obwodów.",
    },
    {
      q: "Jak nadmorski klimat Koszalina wpływa na instalacje techniczne budynków?",
      a: "Wilgotny klimat morski i bliskość Bałtyku przyspieszają korozję instalacji gazowych i degradację izolacji elektrycznych w koszalińskich budynkach. Właściciele nieruchomości powinni planować regularne przeglądy, by uniknąć kosztownych awarii i problemów ubezpieczeniowych.",
    },
    {
      q: "Czy coroczny przegląd gazowy obowiązuje w koszalińskich blokach?",
      a: "Tak — coroczny przegląd instalacji gazowej jest wymogiem prawnym dla wszystkich budynków wyposażonych w gaz w Koszalinie, bez wyjątku. Brak aktualnego protokołu może skutkować mandatem i odmową odszkodowania przez ubezpieczyciela.",
    },
    {
      q: "Jak zamówić przegląd instalacji w Koszalinie i okolicach?",
      a: "Platforma inspektomat.pl obsługuje Koszalin i okoliczne miejscowości (Kołobrzeg, Białogard, Mielno, Sławno). Jedno zapytanie online trafia do kilku certyfikowanych firm — porównujesz oferty i umawiasz się bez zbędnego szukania.",
    },
  ],
};

export function getCityFaqs(slug: string): CityFaq[] {
  return CITY_FAQS[slug] ?? [];
}
